const PactNames =
{
    AcceptanceOfSupremacy: "Acceptance of Supremacy",
    InternationalTourism: "International Tourism",
    InternationalTradeAgreement: "International Trade Agreement",
    LossOfSovereignty: "Loss of Sovereignty",
    MilitaryAlliance: "Military Alliance",
    NavalTradeAgreement: "Naval Trade Agreement",
    OpenBordersAgreement: "Open Borders Agreement",
    PeaceTreaty: "Peace Treaty",
    PromiseOfMilitaryProtection: "Promise of Military Protection",
    ScientificCooperation: "Scientific Cooperation",
    TradeRoutesAgreement: "Trade Routes Agreement",
}

module.exports = PactNames;